module.exports = __webpack_public_path__ + "img/touch_logo.a2f0098d.png";